import React, {useState, useEffect, use} from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, TextField, InputLabel, Select, MenuItem
} from '@mui/material';
import { saveMemberRefund } from '../../Services/loadOrder';
import { toast } from 'react-hot-toast';

const RefundCostShareModal = ({ open, onClose, onConfirm, memberID, pharmacyId, pharmName, contract, refundData, dropdownData }) => {

  const [formData, setFormData] = useState({
    memberID: memberID || '',
    pharmacyId: pharmacyId || '',
    contract: contract || '',
    pharmName: pharmName || '',
    date: '',
    amount: '',
    claimId: '',
    orderAmount: '',
  });
  // useEffect(() => {
  //   console.log(formData);
  //   console.log(refundData);
  // }, [memberID, pharmacyId, contract]);

  const handleOnConfirm = async () => {
    try {
      if (!formData.amount || !formData.date) {
        toast.error('Please fill in all required fields.');
        return;
      }
    const result = await saveMemberRefund(
      formData
    );
    if (result) {
      console.log("Refund successful:", result);
      onConfirm();
      onClose();
    }} catch (error) {
      console.error("Error saving refund:", error);
    }
  }

  const handleOnCancel = () => {
    setFormData({
      date: '',
      amount: '',
      claimId: '',
    });
    onClose();
  }

  useEffect(() => {
    console.log("formData", formData);
    console.log("dropDownData", dropdownData);  
  }, [formData]);

  return (
    <Dialog open={open} onClose={onClose}>
         <DialogTitle>Refund issued to member</DialogTitle>
         
    <DialogContent sx={{
      maxHeight: 400, // or any value you prefer
      overflowY: 'auto'
    }}>
       <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
        <Typography variant="subtitle1" component="div" sx={{ minWidth: 120 }}>
           Amount  <span style={{color: 'red'}}>*</span>
        </Typography>
        <TextField
          fullWidth
        //   label="Enter Amount"
          type='float'
          variant="outlined"
          size="small"
            value={formData.amount || ''}  
            onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
           sx={{
        marginLeft: 2,
        '& .MuiOutlinedInput-root': {
          borderRadius: '10px', // Add border radius
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ec008c', // Highlight border on focus
            boxShadow: '0 0 0 2px rgba(236,0,140,0.15)', // Optional: subtle glow
          },
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '10px', // Ensure border radius on default
        },
      }}
            required
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16, marginTop: 24 }}>
      <Typography variant="subtitle1" component="div" sx={{ minWidth: 120 }}>
        Date  <span style={{color: 'red'}}>*</span>
      </Typography>
      <TextField
      fullWidth
    //   label="Enter Date"
      variant="outlined"
      size="small"
      type='date'
      value={formData.date || ''}
      onChange={(e) => setFormData({ ...formData, date: e.target.value })}
      sx={{
        marginLeft: 2,
        '& .MuiOutlinedInput-root': {
          borderRadius: '10px', // Add border radius
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ec008c', // Highlight border on focus
            boxShadow: '0 0 0 2px rgba(236,0,140,0.15)', // Optional: subtle glow
          },
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '10px', // Ensure border radius on default
        },
      }}
      required
    />
    </div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16, marginTop: 24 }}>
      <Typography variant="subtitle1" component="div" sx={{ minWidth: 120 }}>
        Select ClaimId 
      </Typography>
      <Select
      fullWidth
      variant="outlined"
      size="small"
      displayEmpty
      value={formData.claimId || ''}
      onChange={e =>{
        const selected = dropdownData.find(item => item.value === e.target.value);
        console.log("selected", selected); 
        setFormData({ ...formData, claimId: e.target.value ,
        orderAmount: selected ? selected.orderAmount : ''
      })}}
      >
        <MenuItem value="" disabled>
          Select ClaimId
        </MenuItem>
        {dropdownData && dropdownData.length > 0 ? (
          dropdownData.map((item, index) => (
            <MenuItem key={index} value={item.value}>
              {item.label}
            </MenuItem>
          ))
        ) : (
          <MenuItem value="" disabled>
            No ClaimIds available
          </MenuItem>
        )}
      </Select>
    </div>
     
      
      {/* Show refund history table if refundData exists and has items */}
      {Array.isArray(refundData) && refundData.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ background: '#f5f5f5' }}>
                <th style={{ border: '1px solid #ddd', padding: 8, color: '#ec008c' }}>Claim ID</th>
                <th style={{ border: '1px solid #ddd', padding: 8, color: '#ec008c' }}>Order Amount</th>
                <th style={{ border: '1px solid #ddd', padding: 8, color: '#ec008c' }}>Refund Amount</th>
                <th style={{ border: '1px solid #ddd', padding: 8, color: '#ec008c' }}>Refund Date</th>
              </tr>
            </thead>
            <tbody>
              {refundData.map((row, idx) => (
                <tr key={idx}>
                  <td style={{ border: '1px solid #ddd', padding: 8, textAlign: 'center' }}>{row.ClaimID}</td>
                  <td style={{ border: '1px solid #ddd', padding: 8, textAlign: 'center' }}>{row.OrderAmount}</td>
                  <td style={{ border: '1px solid #ddd', padding: 8, textAlign: 'center' }}>{row.RefundAmount}</td>
                  <td style={{ border: '1px solid #ddd', padding: 8, textAlign: 'center' }}>{row.RefundDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </DialogContent>
    
          <DialogActions>
            <Button onClick={   
                handleOnCancel
            }
            sx={{
              backgroundColor: '#ec008c',
              color: 'white',
              '&:hover': {
                backgroundColor: '#d5006d',
              },
      }}>Cancel</Button>
            <Button
          //    onClick={onConfirm}
              variant="contained"
               onClick={handleOnConfirm}
              //color="primary"
            sx={{
                backgroundColor: '#ec008c',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#d5006d',
                },
              }}          
            //  disabled={disableConfirm || currentReason === ''}
            
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
  );
};

export default RefundCostShareModal;